import { Box, Typography } from "@mui/joy";
import { useNavigate } from "react-router";

import { FadeIn, PrimaryButton } from "~/common/components";
import { RoutePaths } from "~/common/constants/route-paths";

export const CallToAction = () => {
  const navigate = useNavigate();

  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        background:
          "radial-gradient(1655px 1133px at 50% calc(0% - 69px),#b8b4f0 1.11%,#6763e4 28.73%,#453bb3 45.76%,#29227d 63.37%,#1e2064 78.67%,#141e4b 100%)",
        height: { xs: "auto", md: 418 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        py: { xs: 6, sm: 8, md: "80px" },
        px: { xs: 2, sm: 4, md: 6, lg: "120px" },
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          textAlign: "center",
          gap: { xs: 2, md: 3 },
          maxWidth: 1200,
          width: "100%",
        }}
      >
        <FadeIn offsetY={20} duration={300} delay={100}>
          <Typography
            level="h2"
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 500,
              fontSize: {
                xs: "1.5rem",
                sm: "2rem",
                md: "2.5rem",
                lg: "48px",
              },
              lineHeight: "117%",
              letterSpacing: 0,
              color: "common.white",
              textAlign: "center",
              textWrap: "balance",
            }}
          >
            Усі статуси та дедлайни по ТМ у вашому Telegram. Витрачайте на 80%
            менше часу на супровід заявок.
          </Typography>
        </FadeIn>

        <FadeIn offsetY={20} duration={300} delay={200}>
          <Typography
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 400,
              fontSize: { xs: "14px", sm: "15px", md: "16px" },
              lineHeight: "175%",
              letterSpacing: "0.15px",
              color: "common.white",
              textAlign: "center",
              textWrap: "balance",
              maxWidth: 1200,
            }}
          >
            Надійний автоматичний моніторинг для IP-юристів. Brandly щодня
            синхронізує статуси заявок і завчасно попереджає про дедлайни,
            заощаджуючи години на тиждень.
          </Typography>
        </FadeIn>

        <FadeIn offsetY={20} duration={300} delay={300}>
          <PrimaryButton
            size="lg"
            variant="outlined"
            onClick={() => navigate(RoutePaths.PRICING)}
            sx={{
              px: { xs: 3, md: 4 },
              py: { xs: 1.25, md: 1.5 },
              fontSize: { xs: "sm", md: "md" },
              fontWeight: 600,
              bgcolor: "white",
              color: "primary.500",
              borderColor: "common.white",
              "&:hover": {
                bgcolor: "rgba(255, 255, 255, 0.9)",
                borderColor: "common.white",
              },
            }}
          >
            Розпочати
          </PrimaryButton>
        </FadeIn>
      </Box>
    </Box>
  );
};
